import { render } from "./CMessage.vue?vue&type=template&id=d4a239e2"
import script from "./CMessage.vue?vue&type=script&lang=js"
export * from "./CMessage.vue?vue&type=script&lang=js"

import exportComponent from "/home/ydf/remit/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__